import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

export function Logo({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      className={cn(
        "hover:opacity-80 transition-opacity",
        className
      )}
    >
      <img src="/cosx-logo.svg" alt="COSX" className="h-[20px] w-auto dark:hidden" width="68" height="20" fetchPriority="high" />
      <img src="/logo-dark.svg" alt="COSX" className="h-[20px] w-auto hidden dark:block" width="68" height="20" fetchPriority="high" />
    </Link>
  );
}
